import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TrustBadgeProps {
  icon: LucideIcon;
  label: string;
  color?: 'green' | 'blue' | 'purple' | 'pink';
}

const colorClasses = {
  green: 'text-green-400',
  blue: 'text-blue-400',
  purple: 'text-purple-400',
  pink: 'text-pink-400',
};

export function TrustBadge({ icon: Icon, label, color = 'green' }: TrustBadgeProps) {
  return (
    <div className="flex items-center gap-2 text-muted-foreground text-sm">
      <Icon className={cn('h-5 w-5', colorClasses[color])} />
      <span>{label}</span>
    </div>
  );
}
